import classNames from 'classnames';
import { Component } from 'react';
import Button from '../react-ui-button';
import SplitButtonDropdown from './dropdown';
import './index.scss';
import { ButtonProps } from './types';

interface Props extends ButtonProps {
  dropup?: boolean;
  dropleft?: boolean;
  primary?: boolean;
  secondary?: boolean;
  className?: string;
  disabled?: boolean;
  alternativeOptions: ButtonProps[];
  alternativeDisabled?: boolean;
  spinner?: boolean;
  testid?: string;
}

interface State {
  dropdownOpen: boolean;
}

class SplitButton extends Component<Props, State> {
  public static defaultProps = {
    alternativeOptions: [],
    className: '',
    primary: true,
    secondary: false,
  };

  public state = { dropdownOpen: false };

  private toggle = () => {
    this.setState((prevState) => ({
      dropdownOpen: !prevState.dropdownOpen,
    }));
  };

  private onSecondaryClick = (option?: ButtonProps) => {
    this.toggle();
    if (option) {
      option.onClick();
    }
  };

  private renderMainButton(withSpinner = false) {
    const {
      children,
      disabled,
      id,
      onClick,
      secondary,
      spinner,
      text,
      testid,
    } = this.props;
    return (
      <Button
        id={id}
        type="button"
        className="SplitButton__mainAction"
        primary={!secondary}
        secondary={!!secondary}
        onClick={onClick}
        disabled={disabled}
        displaySpinner={withSpinner ? spinner : false}
        testid={testid}
      >
        {text || children}
      </Button>
    );
  }

  private renderSplitButton() {
    const {
      alternativeDisabled,
      alternativeOptions,
      className,
      disabled,
      dropleft,
      dropup,
      id,
      secondary,
      spinner,
    } = this.props;
    const { dropdownOpen } = this.state;
    return (
      <div className={classNames('SplitButton', 'btn-group', className)}>
        {this.renderMainButton()}
        <div className={classNames('btn-group', { open: dropdownOpen })}>
          <Button
            id={`${id}-toggle`}
            type="button"
            className={classNames(
              'dropdown-toggle',
              spinner && 'dropdown-toggle--spinner',
              !secondary && 'darken-left-border'
            )}
            primary={!secondary}
            secondary={!!secondary}
            onClick={this.toggle}
            disabled={
              alternativeDisabled != null ? alternativeDisabled : disabled
            }
            displaySpinner={spinner}
          />
          {dropdownOpen && (
            <SplitButtonDropdown
              options={alternativeOptions}
              onClick={this.onSecondaryClick}
              dropup={dropup}
              dropleft={dropleft}
            />
          )}
        </div>
      </div>
    );
  }

  private renderNormalButton() {
    const { className } = this.props;
    return (
      <div className={`SplitButton ${className}`}>
        {this.renderMainButton(true)}
      </div>
    );
  }

  public render() {
    if (this.props.alternativeOptions.length) {
      return this.renderSplitButton();
    }
    return this.renderNormalButton();
  }
}

export default SplitButton;
